import {NotificationRow} from "../types";

export interface NotificationsPayload {
  totalPageCount: number;
  currentPageNumber: number;
  list: NotificationRow[];
  totalResultCount: number;
}

export interface NotificationsState {
  listLoading: boolean;
  pageCount: number;
  currentPageNumber: number;
  entities: NotificationRow[] | null;
  totalResult: number;
  error: string | null;
}

export const actionTypes = {
  notificationsFetched: 'NOTIFICATIONS_FETCHED',
  notificationsAppended: 'NOTIFICATIONS_APPENDED',
  catchError: 'CATCH_ERROR'
} as const;

type NotificationsAction =
  | {
  type: typeof actionTypes.notificationsFetched;
  payload: NotificationsPayload;
}
  | {
  type: typeof actionTypes.notificationsAppended;
  payload: NotificationsPayload;
}
  | {
  type: typeof actionTypes.catchError;
  payload: { error: string };
};

const defaultState: NotificationsState = {
  listLoading: false,
  pageCount: 0,
  currentPageNumber: 0,
  entities: null,
  totalResult: 0,
  error: null,
};

export const notificationsReducer = (state: NotificationsState = defaultState, action: NotificationsAction): NotificationsState => {
  switch (action.type) {
    case actionTypes.notificationsFetched: {
      const { totalPageCount, currentPageNumber, list, totalResultCount } = action.payload;
      return {
        ...state,
        listLoading: false,
        pageCount: totalPageCount,
        currentPageNumber,
        entities: list,
        totalResult: totalResultCount,
        error: null,
      };
    }
    case actionTypes.notificationsAppended: {
      const { totalPageCount, currentPageNumber, list, totalResultCount } = action.payload;
      return {
        ...state,
        listLoading: false,
        pageCount: totalPageCount,
        currentPageNumber,
        entities: state.entities
          ? [...state.entities, ...list]
          : [...list],
        totalResult: totalResultCount,
        error: null,
      };
    }
    case actionTypes.catchError: {
      const error = `NOTIFICATIONS: ${action.payload.error}`;
      return { ...state, error };
    }

    default:
      return state;
  }
}

export const actions = {
  notificationsFetched: (data: NotificationsPayload) => ({
    type: actionTypes.notificationsFetched,
    payload: data,
  }),
  notificationsAppended: (data: NotificationsPayload) => ({
    type: actionTypes.notificationsAppended,
    payload: data,
  }),
  catchError: (error: string) => ({
    type: actionTypes.catchError,
    payload: {error},
  }),
};